import { render, staticRenderFns } from "./MatchingOrderDetail.vue?vue&type=template&id=43eace63&"
import script from "./MatchingOrderDetail.vue?vue&type=script&lang=js&"
export * from "./MatchingOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./MatchingOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports